import React, {useState} from 'react'
import './blogs_relacionados.css'
import { Tooltip } from 'react-tooltip'
import { detalle_blog } from '../../../assets/data/detalle_blog_header'
import { useTranslation } from 'react-i18next';

const Blogs_relacionados = ({blogsRelacionados, categorias}) => {
    const i = 0 ;

    const [t, i18n] = useTranslation("detail_blog");
    const [activeImage, setActiveImagen] = useState(null);

    const handleImageClick = (index) => {
        setActiveImagen(index === activeImage ? null : index);
    };

    const liga_lang2='/'+i18n.language+"/Ideas-en-libertad";
    
  return (
    <div className="DB_blogsRelacionados">
        <div className="blogsR_titulo">
            <h2>{(t('related.related-entries'))}</h2>
        </div>
        <div className="blogsR_show">
        {blogsRelacionados.map((blog, i) => {
          const liga_lang1 = `/blog/${blog.tag}`;

          return (
            <div key={blog.titulo} className="blogsR_card" id={`blog_${i}`}>
              <div className="blogsR_cardBody" style={{ backgroundImage: `url(${blog.urlImagen})` }}>
               <a href={liga_lang1}>
                  <button>{t('related.read-entry')}</button>
                </a>
              </div>
              <div className="blogsR_cardTitle">
                <p>{blog.titulo}</p>
              </div>
            </div>
          );
        })}
        </div>
        <div className="blogsR_button">
            <a href={liga_lang2}>
            <button style={{width: 150}}>{(t('related.explore-more'))}</button>
            </a>
        </div>
        <div className="blogsR_titulo titulo2_det">
            <h2>{(t('related.category-more'))}</h2>
        </div>
        <div className="blog_categorias categorias2_det">
        
        {
          categorias.length > 0 && categorias.map((categoria) => {
            const { nombre, tagCategory, poster } = !!categoria && categoria;
            return(
              <a href={'/es/Ideas-en-libertad?categoria='+categoria.tagCategory.toLowerCase()+'#tocategory'}>
              <img key={ tagCategory } 
              className={ `categoria_1 ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}` } 
              src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
              
              />
              <p>{categoria?.nombre ?? ""}</p>
              </a>
              
            )
          })
          
        }
         <Tooltip 
                                    id="tooltip-section1" 
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />

        {/* <img className="categoria_1" src={'../../..'+detalle_blog[0].categorias[0].poster}/>
        <img className="categoria_2" src={'../../..'+detalle_blog[0].categorias[1].poster}/>  */}
      </div>
        
    </div>
  )
}

export default Blogs_relacionados
